















































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getData, UserData, emptyUser } from '@/api/systemManage/user'
import { enUserType } from '@/configs/enums'
import ViewDialog from '@/components/dialog/viewDialog.vue'

@Component({
  components: {
    ViewDialog
  }
})
export default class UserView extends Vue {
  public collapseNames: string[] = ["base", "clients"]
  public showDialog: boolean = false
  public loading: boolean = false

  public form: UserData = Object.assign({}, emptyUser)

  public layOut = {
    showInstitute: false,
    showCity: false,
    showCounty: false,
    showTownship: false,
    showUnit: false,

    showRspblty: false,
    showExpert: false,
  }
  public setLayout() {
    const f = this.form
    const userType = f.UserType
    /*
    1省级文物局 2省财政用户 3市文物局 4市财政用户 5区县用户
    6评估机构用户 7评估专家 8文保单位用户 9巡查人员用户
    */
    //6评估机构用户 7评估专家
    const showInstitute = (userType === enUserType.ReviewInstitute || userType === enUserType.Expert)
    const showExpert = userType === enUserType.Expert
    //市级 县级
    const showCity = (userType === enUserType.CityHeritage || userType === enUserType.CityFinance || userType === enUserType.County)
    const showCounty = userType === enUserType.County
    const showRspblty = userType === enUserType.HeritagPatrol
    const showUnit = userType === enUserType.HeritagUnit
    const showTownship = userType == enUserType.Township
    this.layOut = {
      showInstitute: showInstitute,
      showCity: showCity,
      showCounty: showCounty,
      showTownship: showTownship,
      showUnit: showUnit,
      showRspblty: showRspblty,
      showExpert: showExpert
    }
  }
  public $refs!: {}
  public created() { }
  public mounted() {
    window.eventBus.$on("viewUser", (id: number) => {
      this.showDialog = true
      this.fetchData(id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("viewUser")
  }
  public closeDialog() {
    this.showDialog = false
  }
  public fetchData(id: number) {
    this.loading = true
    getData(id)
      .then((response: { data: any }) => {
        this.form = response.data
        this.setLayout()
        this.loading = false
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
}
